<template>
  <div class="horizontal-scroll-wrapper">
    <template v-for="item in item.media_items">
      <component
        :key="item.id"
        :item="item"
        :is="'item-' + item.type"/>
    </template>

  </div>
</template>

<script>
import itemImage from './image'
import itemVideo from './video'
import itemPdf from './pdf'
import itemAudio from './audio'

export default {
  components: {
    itemImage,
    itemVideo,
    itemAudio,
    itemPdf
  },
  props: {
    item: {
      type: Object,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'assets/stylesheets/main.scss';
@import 'node_modules/bootstrap/scss/bootstrap-grid.scss';

.horizontal-scroll-wrapper {
  display: flex;
  padding: 1.25rem;
  align-items: center;
  flex-wrap: nowrap;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  -ms-overflow-style: -ms-autohiding-scrollbar;
}

@include media-breakpoint-down(xs) {
  .horizontal-scroll-wrapper {
    padding: $spacing-xs;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/pages/client/items/media-group.vue